import React from 'react';
import SearchableFiltersList from './SearchableFiltersList';

function MultiSelectFilterSection(props) {
  return <SearchableFiltersList {...props} />;
}

export default MultiSelectFilterSection;
